<template>
    <div>
        <div class="d-flex flex-column align-items-center">
            <div class="h3">
                {{ projectNumberHeader }}
            </div>
            <div
                class="h2"
                data-test-role="payment-receipt-project-number">
                {{ receiptInfo.ProjectNumber }}
            </div>
        </div>
        <div v-if="receiptInfo.IsManualPayment">
            <div>{{ paymentIntentMessage }}</div>
            <div>
                {{ paymentIdHeader }}
                <span data-test-role="receipt-number">
                    {{ receiptInfo.ReceiptNumber }}
                </span>
            </div>
        </div>
        <div v-else-if="!hideReceiptInfo">
            <div class="h3">
                {{ paymentDetailsHeader }}
            </div>
            <div v-if="receiptInfo.PayerEmail">
                <div>{{ confirmationMessage }}</div>
                <div>{{ receiptInfo.PayerEmail }}</div>
            </div>
            <div class="mt-3">
                <div v-if="receiptInfo.PayerName">
                    {{ paidByMessageLoc }}
                </div>
                <div v-if="receiptInfo.ReceiptNumber">
                    {{ paymentIdHeader }}
                    <span data-test-role="receipt-number">
                        {{ receiptInfo.ReceiptNumber }}
                    </span>
                </div>
                <div>
                    {{ feeMessageLoc }}
                </div>
                <div>
                    {{ dateMessageDateLoc }}
                </div>
                <div
                    v-if="displayAmountBreakdown"
                    class="mt-2">
                    <table>
                        <tbody>
                            <tr>
                                <td style="text-align: left">Charge Amount:</td>
                                <td>&nbsp;</td>
                                <td style="text-align: right">
                                    {{ receiptInfo.BaseChargeAmount }}
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align: left">Transaction Fee:</td>
                                <td>&nbsp;</td>
                                <td style="text-align: right">
                                    {{ receiptInfo.SurchargeAmount }}
                                </td>
                            </tr>
                            <tr>
                                <td style="text-align: left">Total Amount:</td>
                                <td>&nbsp;</td>
                                <td style="text-align: right">
                                    {{ receiptInfo.Amount }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else>
                    {{ baseAmountMessageLoc }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { KEYS, NAMESPACE } from "./i18n/paymentReceipt.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        props: {
            receiptInfo: { type: Object, required: true },
            hideReceiptInfo: { type: Boolean, required: false, default: false }
        },
        computed: {
            displayAmountBreakdown() {
                return this.receiptInfo.SurchargeAmount !== "";
            },
            ...mapI18n(
                {
                    ...KEYS,
                    paidByMessageLoc() {
                        return {
                            key: KEYS.paidByMessage,
                            values: { payerName: this.receiptInfo.PayerName }
                        };
                    },
                    feeMessageLoc() {
                        return {
                            key: KEYS.feeMessage,
                            values: { feeDescription: this.receiptInfo.Description }
                        };
                    },
                    baseAmountMessageLoc() {
                        return {
                            key: KEYS.baseAmountMessage,
                            values: { feeAmount: this.receiptInfo.BaseChargeAmount }
                        };
                    },
                    dateMessageDateLoc() {
                        return {
                            key: KEYS.dateMessageDate,
                            values: { paymentDate: this.receiptInfo.ReceiptTimestamp.Display }
                        };
                    }
                },
                NAMESPACE
            )
        }
    };
</script>
